import { ApiInstance } from "@/api";

import type { AxiosResponse } from "axios";
import type { LabelTemplateDTO } from "@/api/classes/labelTemplate/labelTemplate.dto";

export default class LABEL_TEMPLATE_API {
  static async getAllPersonalLabelTemplates(): Promise<
    AxiosResponse<LabelTemplateDTO[]>
  > {
    return ApiInstance.get<LabelTemplateDTO[]>("/LabelTemplate/all");
  }

  static async getAllCommonLabelTemplates(): Promise<
    AxiosResponse<LabelTemplateDTO[]>
  > {
    return ApiInstance.get<LabelTemplateDTO[]>("/LabelTemplate/all/common");
  }

  static async getPersonalLabelTemplateById(
    labelTemplateId: LabelTemplateDTO["id"],
  ): Promise<AxiosResponse<LabelTemplateDTO>> {
    return ApiInstance.get<LabelTemplateDTO>(
      `/LabelTemplate/ById/${labelTemplateId}`,
    );
  }

  static async getCommonLabelTemplateById(
    labelTemplateId: LabelTemplateDTO["id"],
  ): Promise<AxiosResponse<LabelTemplateDTO>> {
    return ApiInstance.get<LabelTemplateDTO>(
      `/LabelTemplate/common/${labelTemplateId}`,
    );
  }

  static async deletePersonalLabelTemplateById(
    labelTemplateId: LabelTemplateDTO["id"],
  ): Promise<AxiosResponse> {
    return ApiInstance.delete(`/LabelTemplate/ById/${labelTemplateId}`);
  }

  static async deleteCommonLabelTemplates(
    labelTemplateIds: LabelTemplateDTO["id"][],
  ): Promise<AxiosResponse> {
    return ApiInstance.delete("/LabelTemplate/common", {
      data: labelTemplateIds,
      headers: { "Content-Type": "application/json" },
    });
  }

  static async createPersonalLabelTemplate(
    label: LabelTemplateDTO,
  ): Promise<AxiosResponse> {
    return ApiInstance.post("/LabelTemplate", label);
  }

  static async createCommonLabelTemplate(
    label: LabelTemplateDTO,
  ): Promise<AxiosResponse> {
    return ApiInstance.post("/LabelTemplate/common", label);
  }

  static async updatePersonalLabelTemplate(
    label: LabelTemplateDTO,
  ): Promise<AxiosResponse> {
    return ApiInstance.put("/LabelTemplate", label);
  }

  static async updateCommonLabelTemplate(
    label: LabelTemplateDTO,
  ): Promise<AxiosResponse> {
    const { id, ...labelTemplateData } = label;
    return ApiInstance.put(`/LabelTemplate/common/${id}`, labelTemplateData);
  }

  static async updateLabelTemplatePrinter(
    label: LabelTemplateDTO["id"],
    printer: string | null,
  ): Promise<AxiosResponse> {
    return ApiInstance.patch(
      `/LabelTemplate/LabelTemplateAttachedPrinterName/${label}?attachedPrinterName=${printer}`,
    );
  }

  static async setDefaultLabelTemplate(
    labelId: LabelTemplateDTO["id"],
  ): Promise<AxiosResponse> {
    return ApiInstance.patch("/LabelTemplate/default", {
      lableId: labelId, // ошибка на бэке в названии
      isDefault: true,
    });
  }
}
